import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useFetchContent from './useFetchContent';
import SearchInfoPage from './SearchInfoPage';

const Recipes = () => {
  const { recipeId: urlRecipeId } = useParams();
  const [recipeId, setRecipeId] = useState(urlRecipeId);
  const navigate = useNavigate();

  useEffect(() => {
    setRecipeId(urlRecipeId);
  }, [urlRecipeId]);

  const transformData = (recipe) => ({
    title: recipe[1],
    sections: [
      { label: 'Od jakiego wieku?', value: `${recipe[2]} miesięcy` },
      { label: 'Popularne alergeny w przepisie', value: recipe[3].replace(/;/g, ', ') },
      {
              label: 'Potrzebne składniki',
              value: (
                <ul>
                  {recipe[5].trim().split('\n').map((step, index) => (
                    <li key={index}>{step.replace(/^[0-9]+\.\s*/, '')}</li>
                  ))}
                </ul>
              ),
            },
      { label: 'Orientacyjny czas przygotowania', value: `${recipe[4]} minut` },
      {
        label: 'Przepis krok po kroku',
        value: (
          <ol>
            {recipe[6].trim().split('\n').map((step, index) => (
              <li key={index}>{step.replace(/^[0-9]+\.\s*/, '')}</li>
            ))}
          </ol>
        ),
      },
    ],
  });

  const { contentSections, isLoading, error, setError={setError} } = useFetchContent(true, recipeId, transformData);

  const handleSearch = (newRecipeId) => {
    navigate(`/przepisy/${newRecipeId}`);
  };

  return (
    <SearchInfoPage
      isLoading={isLoading}
      isRecipes={true}
      productId={recipeId}
      setProductId={handleSearch}
      title="Przepisy"
      searchPlaceholder="Wyszukaj przepis..."
      contentSections={contentSections}
      error={error}
      setError={setError}
    />
  );
};

export default Recipes;